/**
 * @generated SignedSource<<564d9d4aa88a71a9911766f561e849e1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type JiraIntegrationLinkQuery$variables = {
  key: string;
};
export type JiraIntegrationLinkQuery$data = {
  readonly project: {
    readonly integration: {
      readonly id: string;
      readonly issue: {
        readonly href: string | null;
      } | null;
    } | null;
    readonly uuid: string;
  } | null;
};
export type JiraIntegrationLinkQuery = {
  response: JiraIntegrationLinkQuery$data;
  variables: JiraIntegrationLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "concreteType": "ProjectFusion",
  "kind": "LinkedField",
  "name": "integration",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "concreteType": "GqlJiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "href"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "JiraIntegrationLinkQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JiraIntegrationLinkQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "783540c1e15d1f876793aa398c440d0c",
    "id": null,
    "metadata": {},
    "name": "JiraIntegrationLinkQuery",
    "operationKind": "query",
    "text": "query JiraIntegrationLinkQuery(\n  $key: String!\n) {\n  project: projectByKey(key: $key) {\n    uuid\n    integration {\n      id\n      issue {\n        href\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b96d515e32619673d5a5d2bca20e2320";

export default node;
